.container {
  padding: 10px;
  border-top: 1px solid var(--color-gray-s4);
}
